import { REFRESH_KEY } from '../constants';
const setRefreshToken = data => {
  if (!data) return;
  const {
    loginResult: {
      result
    }
  } = data;
  if (!result) return;
  const {
    refreshToken
  } = result;
  window.localStorage.setItem(REFRESH_KEY, refreshToken);
};
export default setRefreshToken;
//# sourceMappingURL=set-refresh-token.js.map